import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from "swiper/modules";

export default function heroSwiper() {
    function getResponsiveInfo(elm: Element | null | undefined) {
        return elm
            ? window.getComputedStyle(elm, '::after')?.content.replace(/['"]+/g, '')
            : false;
    }

    const responsiveCheckElement = document.getElementById('responsive-check');

    if (!responsiveCheckElement) {
        const newResponsiveCheckElement = document.createElement('div');
        newResponsiveCheckElement.classList.add('responsive-check');
        newResponsiveCheckElement.id = 'responsive-check';

        document.body.appendChild(newResponsiveCheckElement);
    }

    let swiperInstance: Swiper | null = null;
    handleResize();

    function handleResize() {
        const responsiveCheckElement = document.getElementById('responsive-check');
        const content = getResponsiveInfo(responsiveCheckElement);

        if (content === 'desktop' && swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
            const swiperNavigationElement = document.querySelectorAll('.swiper-navigation');
            if(swiperNavigationElement?.[0]) {
                swiperNavigationElement[0].remove()
            }

        } else if (content === 'mobile' && !swiperInstance) {
            const swiper = document.querySelectorAll('.swiper')
            if(swiper?.[0]) {
                const swiperNavigationElement = document.querySelectorAll('.swiper-navigation');
                if(!swiperNavigationElement[0]) {
                    const swiperNavigation = document.createElement('div');
                    swiperNavigation.classList.add('swiper-navigation');

                    const prevButton = document.createElement('button');
                    prevButton.classList.add('swiper-button-prev');
                    swiperNavigation.append(prevButton);

                    const nextButton = document.createElement('button');
                    nextButton.classList.add('swiper-button-next');
                    swiperNavigation.append(nextButton);

                    swiper[0].prepend(swiperNavigation);
                }

                const swiperPaginationElement = document.querySelectorAll('.swiper-pagination');

                if(!swiperPaginationElement[0]) {
                    const swiperPagination = document.createElement('div');
                    swiperPagination.classList.add('swiper-pagination');

                    swiper[0].append(swiperPagination);
                }
            }

            swiperInstance = new Swiper('.swiper', {
                modules: [Navigation, Pagination, Autoplay],
                slidesPerView: 1,
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
        }
    }

    window.addEventListener('resize', handleResize);
}
